import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate, getUrgencyMessage } from '../utils/dateUtils';

const ExhibitionCard = ({ exhibition }) => {
  const getStatusBadgeClass = (status) => {
    const classes = {
      'current': 'badge badge-current',
      'upcoming': 'badge badge-upcoming',
      'ongoing': 'badge badge-ongoing',
    };
    return classes[status] || 'badge';
  };

  const urgencyInfo = getUrgencyMessage(exhibition);

  return (
    <Link to={`/events/${exhibition.id}`} className="block h-full">
      <div className="card hover:shadow-lg transition-shadow duration-200 h-full flex flex-col">
        <div className="p-4 flex-1 flex flex-col">
          {/* Status badge and urgency indicator */}
          <div className="mb-2 flex flex-wrap gap-2 items-center">
            <span className={getStatusBadgeClass(exhibition.status)}>
              {exhibition.status}
            </span>
            {urgencyInfo && (
              <span className={`text-xs px-2 py-1 rounded-full font-medium ${
                urgencyInfo.variant === 'warning' 
                  ? 'bg-amber-100 text-amber-800' 
                  : urgencyInfo.variant === 'success'
                  ? 'bg-emerald-100 text-emerald-800'
                  : 'bg-blue-100 text-blue-800'
              }`}>
                {urgencyInfo.text}
              </span>
            )}
          </div>
          
          {/* Exhibition name */}
          <h3 className="text-lg font-semibold text-slate-900 mb-2 line-clamp-2">
            {exhibition.name}
          </h3>
          
          {/* Date range */}
          <div className="text-sm text-slate-600 mb-3">
            {formatDate(exhibition.start_date)} – {formatDate(exhibition.end_date)}
          </div>
          
          {/* Artists */}
          {exhibition.artists && exhibition.artists.length > 0 && (
            <div className="text-sm text-slate-600 mb-2">
              <span className="font-medium">Artists:</span>{' '}
              {exhibition.artists.slice(0, 2).map(a => a.name).join(', ')}
              {exhibition.artists.length > 2 && ` +${exhibition.artists.length - 2} more`}
            </div>
          )}
          
          {/* Venues */}
          {exhibition.venues && exhibition.venues.length > 0 && (
            <div className="text-sm text-slate-600 mt-auto">
              <span className="inline-flex items-center gap-1">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                {exhibition.venues[0].city || exhibition.venues[0].name}
              </span>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ExhibitionCard;
